
import {FBFieldBaseOptions, FieldTypeEnum} from "../Fields/Core/FBFieldBase.options";
import {FieldFactory} from "../FieldFactory";
import {StoreBase} from "shared/core/Store/StoreBase";


export class FBColumnOptions extends StoreBase{
    public Field:FBFieldBaseOptions;
    public WidthPercentage:number;

    protected LoadDefaultValues() {
        this.Field=new FBFieldBaseOptions();
        this.WidthPercentage=100;
    }




    protected GetValueFromLoader(property:keyof this,value:any):any
    {
        if(property=='Field')
        {
            return FieldFactory.GetFieldOptions(value.Type).Merge(value);
        }

        return null;

    }
}
